import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import UserDetailsPanel from './UserDetails';
import BackgroundNavImage from '../background-nav.jpg'; // Import using relative path
import { Link } from '@mui/material';
import { useAuth } from '../contexts/authContext'

interface AvailableTab {
    title: string,
    option: number,
    forInstitutional: boolean
}

const pages: AvailableTab[] = [
    { title: 'Latest retractions', option: 0, forInstitutional: false },
    { title: 'Author Analysis', option: 1, forInstitutional: false },
    { title: 'Article Analysis', option: 2, forInstitutional: false },    
    { title: 'Reference Analysis', option: 3, forInstitutional: true },
    { title: 'Explorer', option: 4, forInstitutional: false },
    { title: 'API', option: 5, forInstitutional: false },    
    { title: 'Dashboard', option: 6, forInstitutional: false }
    ];

interface ResponsiveAppBarProps {
    selectTab: (newValue: number) => void
}

function ResponsiveAppBar({ selectTab }: ResponsiveAppBarProps) {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const { userLoggedIn, isInstitutionalAccount, isPublisherAccount, isJournalistAccount } = useAuth()

    const handleMenuSelection = (selection: number) => {
        selectTab(selection)
        handleCloseNavMenu()
    }

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };


    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };


    const logoStyle = {
        width: '151px',
        height: '50px',
        cursor: 'pointer'
    };


    return (
        <>
            <AppBar position="static" sx={{
                backgroundColor: '#003366',
                backgroundImage: `url(${BackgroundNavImage})`,
                backgroundPosition: 'bottom',
                verticalAlign: 'center',
                backgroundSize: '100%'
            }}>
                <Container maxWidth="xl" sx={{ pt: 5, minHeight: 150 }}>
                    <Toolbar disableGutters sx={{ verticalAlign: 'center' }}>
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 4 }}>
                            <Link href="/argos">
                                <img
                                    src={
                                        '/argos/static/images/templates/templates-images/B_green circle_4_argosWhite_medium_151x50.png'
                                    }
                                    style={logoStyle}
                                    alt="logo of scitility"
                                />
                            </Link>
                        </Box>

                        <Box sx={{
                            mr: 0,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1
                        }}>
                            <img
                                src={
                                    '/argos/static/images/templates/templates-images/B_green circle_4_argosWhite_medium_151x50.png'
                                }
                                style={logoStyle}
                                alt="logo of scitility"
                            />
                        </Box>
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (
                                (userLoggedIn && (!page.forInstitutional || isInstitutionalAccount || isPublisherAccount || isJournalistAccount)) &&
                                <Button
                                    key={'responsive-option-' + page.option}
                                    onClick={() => handleMenuSelection(page.option)}
                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                >
                                    {page.title}
                                </Button>

                            ))}
                        </Box>

                        <Box sx={{ flexGrow: 0 }}>
                            {!userLoggedIn &&
                                <Button
                                    variant="text"
                                    size="small"
                                    component="a"
                                    href="/argos"
                                    sx={{ color: 'white' }}
                                >
                                    Sign in
                                </Button>}
                            {userLoggedIn &&
                                <UserDetailsPanel selectTab={selectTab} />
                            }
                        </Box>
                        <Box sx={{ flexGrow: 0, display: { xs: 'flex', md: 'none' } }}>
                            {userLoggedIn &&
                                <>

                                    <IconButton
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        onClick={handleOpenNavMenu}
                                        color="inherit"
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorElNav}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        open={Boolean(anchorElNav)}
                                        onClose={handleCloseNavMenu}
                                        sx={{ display: { xs: 'block', md: 'none' } }}
                                    >
                                        {pages.map((page) => (
                                            (userLoggedIn && (!page.forInstitutional || isInstitutionalAccount || isPublisherAccount || isJournalistAccount)) &&
                                            <MenuItem key={'option-' + page.option} onClick={() => handleMenuSelection(page.option)}>
                                                <Typography sx={{ textAlign: 'center' }}>{page.title}</Typography>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </>}
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    );
}
export default ResponsiveAppBar;